// extracted by mini-css-extract-plugin
export default {"apply-btn-wrapper":"checkboxes_apply-btn-wrapper__Wamth"};